import axios from "axios"

class Search {
 // 1. describe and create/initiate our object
 constructor() {
  this.addSearchHTML()
  this.resultsDiv = document.querySelector("#search-overlay__results")
  this.openButton = document.querySelectorAll(".js-search-trigger")
  this.closeButton = document.querySelector(".search-overlay__close")
  this.searchOverlay = document.querySelector(".search-overlay")
  this.searchField = document.querySelector("#search-term")
  this.searchType = document.querySelector("#search-type")
  this.isOverlayOpen = false
  this.isSpinnerVisible = false
  this.previousValue
  this.typingTimer
  this.events()
}

// 2. events
events() {
  this.openButton.forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault()
      this.openOverlay()
    })
  })

  this.closeButton.addEventListener("click", () => this.closeOverlay())
  this.searchField.addEventListener("keyup", (e) => this.checkForEnter(e))
  document.addEventListener("keydown", (e) => this.keyPressDispatcher(e))
  document
    .querySelector("#send-search")
    .addEventListener("click", () => this.getResults())
}

// 3. methods (function, action...)
checkForEnter(e) {
  // If the pressed key is Enter
  console.log("checkForEnter")
  if (e.keyCode === 13 || e.which === 13) {
    this.getResults()
  }
}

async getResults() {
  try {
    const searchTerm = this.searchField.value
    const searchType = this.searchType.value // Get the current selected value
    console.log("searchType: " + searchType)
    const response = await axios.get(
      `${siteData.root_url}/wp-json/fashiontextile/v1/search?term=${searchTerm}&type=${searchType}`
    )
    const results = response.data
    console.log(results)

    

    // Check if there are any results in any of the categories
    const hasResults = Object.keys(results).some(
      (category) => results[category].length > 0
    )

    function isUpcomingOrToday(dateString) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);  // Set to start of today
      const eventDate = new Date(dateString.substring(0, 4), dateString.substring(4, 6) - 1, dateString.substring(6));
      return eventDate >= today;
    }
    
    // Function to format a date string from 'yyyymmdd' to 'dd MMM yyyy'
    function formatDate(dateString) {
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      const date = new Date(dateString.substring(0, 4), dateString.substring(4, 6) - 1, dateString.substring(6));
      return date.toLocaleDateString('en-GB', options);
    }    
    
    const today = new Date();
    const formattedToday = `${today.getFullYear()}${(today.getMonth() + 1).toString().padStart(2, '0')}${today.getDate().toString().padStart(2, '0')}`;



    function groupBy(array, key) {
      return array.reduce((result, item) => {
        let found = result.find(r => r.key === item[key]);
        if (found) {
          found.values.push(item);
        } else {
          result.push({ key: item[key], values: [item] });
        }

        return result;
      }, []);
    }

       

    function exceptions(searchTerm) {
      console.log("exceptions called")
      // Normalize the search term
      let normalizedSearchTerm = searchTerm.trim().toLowerCase().replace(/\s+/g, ' ');
      console.log("searchTerm: " + searchTerm)
      console.log("normalizedSearchTerm:" + normalizedSearchTerm)

  
      // Map of search terms associated with their respective result arrays
      const termMap = {
          'exhibitiondisplays': ['exhibition', 'display', 'exhibitions', 'displays', 'exhibitions and displays', 'exhibitions displays', 'exhibition display'],
          'workshops': ['Workshops', 'workshop', 'workshops'],
          'museumevents': ['events', 'museum events', 'event', 'museum event', 'museumevent'],
          'fashionschools': ['fashion school', 'fashion', 'school', 'fashionschool', 'fashion courses'],
          'onlinetalks': ['onlinetalks', 'online', 'talk', 'online talk', 'talks', 'online talks'],
          'digitaldesigncourses': ['digital', 'digital design', 'courses', 'course', 'digital design course', 'digital design courses', 'design course', 'design courses', 'design class', 'design classes', 'digital design class', 'digital design classes'],
          'ondemands': ['ondemands', 'on demand', 'on demand courses', 'on demand talks', 'on demand lectures'],
          'touringexhibitions': ['touringexhibitions', 'touring exhibition', 'sproot', 'touring exhibitions', 'exhibition', 'exhibitions', 'exhibitions for hire', 'exhibition for hire', 'hire exhibition', 'hire exhibitions']
      };
  
      // Iterate over the map to find the correct array to update
      for (const [resultKey, terms] of Object.entries(termMap)) {
          if (terms.includes(normalizedSearchTerm)) {
            
            console.log(`${resultKey} Entered`);
  
              // Update the correct array in results
              results[resultKey].push({
                  key: terms[0], // Use the first term for the 'key' property
                  title: '', 
                  permalink: '/', 
                  dateFrom: '20501230', 
                  dateTo: '20501230', 
                  featuredImageUrl: '/'
              });
  
              break; // Exit the loop once the correct array is updated
          }
      }
  }
    exceptions(searchTerm)

    console.log("results after exceptions", results)

    if (hasResults) {
      this.resultsDiv.innerHTML = `
        <div class="row">
        ${
          results.generalInfo.length
            ? `
            
            <div class="col-12 col-lg-3 results-container">
                <h2 class="heading-4 search-title">General Information</h2>
                ${
                  results.generalInfo.length
                    ? '<ul>'
                    : "<p>No general information matches that search.</p>"
                }
                ${results.generalInfo
                  .map(
                    (item) =>
                      `<li><a href="${item.permalink}">${item.title}</a> ${
                        item.postType == "post"
                          ? `by ${item.authorName}`
                          : ""
                      }</li>`
                  )
                  .join("")}
                ${results.generalInfo.length ? "</ul>" : ""}
            </div>
            
            `
            : ""
        }

        ${
          results.exhibitiondisplays.filter(item => item.dateTo >= formattedToday).length > 0
              ? `
                  <div class="col-12 col-lg-3 results-container">
                      <h2 class="heading-4 search-title">Exhibitions and Displays</h2>
                      <a class="search-subtitle" href="/exhibitionsdisplays/">View All Exhibitions and Displays</a>
                      ${
                          groupBy(results.exhibitiondisplays.filter(item => (item.dateTo >= formattedToday)), 'title')
                              .map(group => {
                                  return `
                                      <h3>${group.key}</h3>
                                      <ul class="link-list min-list" style="margin-bottom:">
                                          ${group.values.map((item, index, array) => {
                                              const permalinkWithDates = `${item.permalink}?date_from=${item.dateFrom}&date_to=${item.dateTo}`;
                                              const dateRange = (item.dateTo!="20501230")?item.dateFrom === item.dateTo 
                                                ? formatDate(item.dateFrom)
                                                : `${formatDate(item.dateFrom)} - ${formatDate(item.dateTo)}`:"";
                                              
                                              // Include the featured image for the first item
                                              const featuredImage = index === 0 ? `<a href="${permalinkWithDates}"><img src="${item.featuredImageUrl}" class="results-image" alt="${item.title}"></a>` : '';
      
                                              // Additional Dates heading and pipe separator
                                              const additionalDatesHeading = index === 1 ? `<div class="headline headline--teeny-tiny headline--grey headline--uppercase headline--bold additional-dates">Additional Dates:</div>` : '';
                                              const pipeSeparator = index > 0 && index < array.length - 1 ? ' | ' : '';
      
                                              return `
                                                  ${index === 0 ? featuredImage : ''}
                                                  ${additionalDatesHeading}
                                                  <li><a href="${permalinkWithDates}" class="dates-only">${dateRange}</a>${pipeSeparator}</li>
                                              `;
                                          }).join('')}
                                      </ul>
                                  `;
                              }).join('')
                      }
                  </div>
                  `
              : ``
      }

      ${
        results.workshops.filter(item => item.dateTo >= formattedToday).length > 0
            ? `
                <div class="col-12 col-lg-3 results-container">
                    <h2 class="heading-4 search-title">Workshops</h2>
                    <a class="search-subtitle" href="/workshops/">View All Workshops</a>
                    ${
                        groupBy(results.workshops.filter(item => item.dateTo >= formattedToday), 'title')
                            .map(group => {
                                return `
                                    <h3>${group.key}</h3>
                                    <ul class="link-list min-list" style="margin-bottom:">
                                        ${group.values.map((item, index, array) => {
                                            const permalinkWithDates = `${item.permalink}?date_from=${item.dateFrom}&date_to=${item.dateTo}`;
                                            const dateRange = (item.dateTo!="20501230")?item.dateFrom === item.dateTo 
                                                ? formatDate(item.dateFrom)
                                                : `${formatDate(item.dateFrom)} - ${formatDate(item.dateTo)}`:"";
                                            
                                            // Include the featured image for the first item
                                            const featuredImage = index === 0 ? `<a href="${permalinkWithDates}"><img src="${item.featuredImageUrl}" class="results-image" alt="${item.title}"></a>` : '';
    
                                            // Additional Dates heading and pipe separator
                                            const additionalDatesHeading = index === 1 ? `<div class="headline headline--teeny-tiny headline--grey headline--uppercase headline--bold additional-dates">Additional Dates:</div>` : '';
                                            const pipeSeparator = index > 0 && index < array.length - 1 ? ' | ' : '';
    
                                            return `
                                                ${index === 0 ? featuredImage : ''}
                                                ${additionalDatesHeading}
                                                <li><a href="${permalinkWithDates}" class="dates-only">${dateRange}</a>${pipeSeparator}</li>
                                            `;
                                        }).join('')}
                                    </ul>
                                `;
                            }).join('')
                    }
                </div>
                `
            : ``
    }

    ${
      results.museumevents.filter(item => item.dateTo >= formattedToday).length > 0
          ? `
              <div class="col-12 col-lg-3 results-container">
              <h2 class="heading-4 search-title">Museum Events</h2>
              <a class="search-subtitle" href="/museumevents/">View All Museum Events</a>
                  ${
                    groupBy(results.museumevents.filter(item => item.dateTo >= formattedToday), 'title')
                          .map(group => {
                              return `
                                  <h3>${group.key}</h3>
                                  <ul class="link-list min-list" style="margin-bottom:">
                                      ${group.values.map((item, index, array) => {
                                          const permalinkWithDates = `${item.permalink}?date_from=${item.dateFrom}&date_to=${item.dateTo}`;
                                          const dateRange = (item.dateTo!="20501230")?item.dateFrom === item.dateTo 
                                                ? formatDate(item.dateFrom)
                                                : `${formatDate(item.dateFrom)} - ${formatDate(item.dateTo)}`:"";
                                          
                                          // Include the featured image for the first item
                                          const featuredImage = index === 0 ? `<a href="${permalinkWithDates}"><img src="${item.featuredImageUrl}" class="results-image" alt="${item.title}"></a>` : '';
  
                                          // Additional Dates heading and pipe separator
                                          const additionalDatesHeading = index === 1 ? `<div class="headline headline--teeny-tiny headline--grey headline--uppercase headline--bold additional-dates">Additional Dates:</div>` : '';
                                          const pipeSeparator = index > 0 && index < array.length - 1 ? ' | ' : '';
  
                                          return `
                                              ${index === 0 ? featuredImage : ''}
                                              ${additionalDatesHeading}
                                              <li><a href="${permalinkWithDates}" class="dates-only">${dateRange}</a>${pipeSeparator}</li>
                                          `;
                                      }).join('')}
                                  </ul>
                              `;
                          }).join('')
                  }
              </div>
              `
          : ``
  }
          
          ${
            results.fashionschools.filter(item => item.dateTo >= formattedToday).length > 0
                ? `
                    <div class="col-12 col-lg-3 results-container">
                    <h2 class="heading-4 search-title">Fashion School</h2>
                    <a class="search-subtitle" href="/fashionschools/">View All Fashion School</a>
                        ${
                            groupBy(results.fashionschools.filter(item => item.dateTo >= formattedToday), 'title')
                                .map(group => {
                                    return `
                                        <h3>${group.key}</h3>
                                        <ul class="link-list min-list" style="margin-bottom:">
                                            ${group.values.map((item, index, array) => {
                                                const permalinkWithDates = `${item.permalink}?date_from=${item.dateFrom}&date_to=${item.dateTo}`;
                                                const dateRange = (item.dateTo!="20501230")?item.dateFrom === item.dateTo 
                                                ? formatDate(item.dateFrom)
                                                : `${formatDate(item.dateFrom)} - ${formatDate(item.dateTo)}`:"";
                                                
                                                // Include the featured image for the first item
                                                const featuredImage = index === 0 ? `<a href="${permalinkWithDates}"><img src="${item.featuredImageUrl}" class="results-image" alt="${item.title}"></a>` : '';
        
                                                // Additional Dates heading and pipe separator
                                                const additionalDatesHeading = index === 1 ? `<div class="headline headline--teeny-tiny headline--grey headline--uppercase headline--bold additional-dates">Additional Dates:</div>` : '';
                                                const pipeSeparator = index > 0 && index < array.length - 1 ? ' | ' : '';
        
                                                return `
                                                    ${index === 0 ? featuredImage : ''}
                                                    ${additionalDatesHeading}
                                                    <li><a href="${permalinkWithDates}" class="dates-only">${dateRange}</a>${pipeSeparator}</li>
                                                `;
                                            }).join('')}
                                        </ul>
                                    `;
                                }).join('')
                        }
                    </div>
                    `
                : ``
        }

        ${
          results.onlinetalks.filter(item => item.dateTo >= formattedToday).length > 0
              ? `
                  <div class="col-12 col-lg-3 results-container">
                  <h2 class="heading-4 search-title">Online Talks</h2>
                  <a class="search-subtitle" href="/onlinetalks/">View All Online Talks</a>
                      ${
                          groupBy(results.onlinetalks.filter(item => item.dateTo >= formattedToday), 'title')
                              .map(group => {
                                  return `
                                      <h3>${group.key}</h3>
                                      <ul class="link-list min-list" style="margin-bottom:">
                                          ${group.values.map((item, index, array) => {
                                              const permalinkWithDates = `${item.permalink}?date_from=${item.dateFrom}&date_to=${item.dateTo}`;
                                              const dateRange = (item.dateTo!="20501230")?item.dateFrom === item.dateTo 
                                                ? formatDate(item.dateFrom)
                                                : `${formatDate(item.dateFrom)} - ${formatDate(item.dateTo)}`:"";
                                              
                                              // Include the featured image for the first item
                                              const featuredImage = index === 0 ? `<a href="${permalinkWithDates}"><img src="${item.featuredImageUrl}" class="results-image" alt="${item.title}"></a>` : '';
      
                                              // Additional Dates heading and pipe separator
                                              const additionalDatesHeading = index === 1 ? `<div class="headline headline--teeny-tiny headline--grey headline--uppercase headline--bold additional-dates">Additional Dates:</div>` : '';
                                              const pipeSeparator = index > 0 && index < array.length - 1 ? ' | ' : '';
      
                                              return `
                                                  ${index === 0 ? featuredImage : ''}
                                                  ${additionalDatesHeading}
                                                  <li><a href="${permalinkWithDates}" class="dates-only">${dateRange}</a>${pipeSeparator}</li>
                                              `;
                                          }).join('')}
                                      </ul>
                                  `;
                              }).join('')
                      }
                  </div>
                  `
              : ``
      }        

      ${
        results.digitaldesigncourses.filter(item => item.dateTo >= formattedToday).length > 0
            ? `
                <div class="col-12 col-lg-3 results-container">
                  <h2 class="heading-4 search-title">Digital Design Courses</h2>
                  <a class="search-subtitle" href="/digitaldesigncourses/">View All Digital Design Courses</a>
                    ${
                      groupBy(results.digitaldesigncourses.filter(item => item.dateTo >= formattedToday), 'title')
                            .map(group => {
                                return `
                                <h3>${group.key}</h3>
                                    <ul class="link-list min-list" style="margin-bottom:">
                                        ${group.values.map((item, index, array) => {
                                            const permalinkWithDates = `${item.permalink}?date_from=${item.dateFrom}&date_to=${item.dateTo}`;
                                            const dateRange = (item.dateTo!="20501230")?item.dateFrom === item.dateTo 
                                                ? formatDate(item.dateFrom)
                                                : `${formatDate(item.dateFrom)} - ${formatDate(item.dateTo)}`:"";
                                            
                                            // Include the featured image for the first item
                                            const featuredImage = index === 0 ? `<a href="${permalinkWithDates}"><img src="${item.featuredImageUrl}" class="results-image" alt="${item.title}"></a>` : '';
    
                                            // Additional Dates heading and pipe separator
                                            const additionalDatesHeading = index === 1 ? `<div class="headline headline--teeny-tiny headline--grey headline--uppercase headline--bold additional-dates">Additional Dates:</div>` : '';
                                            const pipeSeparator = index > 0 && index < array.length - 1 ? ' | ' : '';
    
                                            return `
                                                ${index === 0 ? featuredImage : ''}
                                                ${additionalDatesHeading}
                                                <li><a href="${permalinkWithDates}" class="dates-only">${dateRange}</a>${pipeSeparator}</li>
                                            `;
                                        }).join('')}
                                    </ul>
                                `;
                            }).join('')
                    }
                </div>
                `
            : ``
    }      

    ${
      results.ondemands.length
        ? 
        `
        <div class="col-12 col-lg-3 results-container">
        <h2 class="heading-4 search-title">On Demand</h2>
        <a class="search-subtitle" href="/ondemands/">View All On Demand</a>
            <ul class="link-list min-list" style="margin-bottom:">
            ${results.ondemands
              .map(
                (item) =>
                  `<li>
                    <h3>${item.title}</h3>
                    <a href="${item.permalink}">${item.featuredImageUrl ? `<img src="${item.featuredImageUrl}" class="results-image" style="left: 0;" alt="${item.title}"></img>` : ''}
                    </a>
                    ${item.dateTo != "20501230" ? `<a href="${item.permalink}" class="max-btn" style="color: white; margin-top: .5rem; display: block;">Find out more</a>` : ""}
                  </li>`).join("")}
            </ul>
        </div>
        
        `
        : ""
    }

    ${
      results.touringexhibitions.length
        ? `
        
        <div class="col-12 col-lg-3 results-container">
        <h2 class="heading-4 search-title">Touring Exhibitions</h2>
        <a class="search-subtitle" href="/touringexhibitions/">View All Touring Exhibitions</a>
            <ul class="link-list min-list" style="margin-bottom:">
            ${results.touringexhibitions
              .map(
                (item) =>
                  `<li>
                    <h3>${item.title}</h3>
                    <a href="${item.permalink}">${item.featuredImageUrl ? `<img src="${item.featuredImageUrl}" class="results-image" style="left: 0;" alt="${item.title}"></img>` : ''}
                    </a>
                    ${item.dateTo != "20501230" ? `<a href="${item.permalink}" class="max-btn" style="color: white; margin-top: .5rem; display: block;">Find out more</a>` : ""}
                  </li>`).join("")}
            </ul>
        </div>
        
        `
        : ""
    }   
              
        </div>
      `;
    } else {
      this.resultsDiv.innerHTML = "<div class='col-12 col-lg-3 results-container'><p>There are no results for your search.</p></div>";
    }   


    this.isSpinnerVisible = false
  } catch (e) {
    console.log(e)
  }
}

keyPressDispatcher(e) {
  if (
    e.keyCode == 83 &&
    !this.isOverlayOpen &&
    document.activeElement.tagName != "INPUT" &&
    document.activeElement.tagName != "TEXTAREA"
  ) {
    this.openOverlay()
  }

  if (e.keyCode == 27 && this.isOverlayOpen) {
    this.closeOverlay()
  }
}

openOverlay() {
  this.searchOverlay.classList.add("search-overlay--active")
  document.body.classList.add("body-no-scroll")
  this.searchField.value = ""
  setTimeout(() => this.searchField.focus(), 301)
  this.isOverlayOpen = true
  return false
}

closeOverlay() {
  this.searchOverlay.classList.remove("search-overlay--active")
  document.body.classList.remove("body-no-scroll")
  this.isOverlayOpen = false
}

addSearchHTML() {
  document.body.insertAdjacentHTML(
    "beforeend",
    `
      <div class="search-overlay">
      <div class="container-fluid" style="padding: 0;">
          <div class="search-overlay__top">
          <div class="container">
          <div class="row search-overlay__top-row">
              <div class="col-12 col-lg-3">
                  <input type="text" class="search-term" placeholder="Please enter search term here" id="search-term" />
              </div>
              <div class="col-12 col-lg-3">
                  <select class="search-filter" id="search-type">
                      <option value="all-site">All Site</option>
                      <option value="all-events">All Events</option>
                      <option value="exhibitiondisplay">Exhibitions & Displays</option>
                      <option value="museumevent">Museum Events</option>
                      <option value="onlinetalk">Online Talks</option>
                      <option value="fashionschool">Fashion School</option>
                      <option value="digitaldesigncourse">Digital Design Courses</option>
                      <option value="ondemand">On Demand</option>
                      <option value="workshop">Workshops</option>
                      <option value="touringexhibition">Touring Exhibitions</option>
                  </select>
              </div>                

              <div class="col-12 col-lg-2">
                  <div id="send-search" class="search-overlay-button">Search</div>
              </div>  
              <div class="col-12 col-lg-2">
                  <div class="search-overlay-button search-overlay__close">Close</div>
              </div>  
              </div>                                             
          </div>
          </div>
          <div class="container">
              <div id="search-overlay__results"></div>
          </div>
      </div>
      </div>
  `
  )
}


  // // 1. describe and create/initiate our object
  // constructor() {
  //   this.addSearchHTML()
  //   this.resultsDiv = document.querySelector("#search-overlay__results")
  //   this.openButton = document.querySelectorAll(".js-search-trigger")
  //   this.closeButton = document.querySelector(".search-overlay__close")
  //   this.searchOverlay = document.querySelector(".search-overlay")
  //   this.searchField = document.querySelector("#search-term")
  //   this.searchType = document.querySelector("#search-type")
  //   this.isOverlayOpen = false
  //   this.isSpinnerVisible = false
  //   this.previousValue
  //   this.typingTimer
  //   this.events()
  // }

  // // 2. events
  // events() {
  //   this.openButton.forEach((el) => {
  //     el.addEventListener("click", (e) => {
  //       e.preventDefault()
  //       this.openOverlay()
  //     })
  //   })

  //   this.closeButton.addEventListener("click", () => this.closeOverlay())
  //   this.searchField.addEventListener("keyup", (e) => this.checkForEnter(e))
  //   document.addEventListener("keydown", (e) => this.keyPressDispatcher(e))
  //   document
  //     .querySelector("#send-search")
  //     .addEventListener("click", () => this.getResults())
  // }

  // // 3. methods (function, action...)
  // checkForEnter(e) {
  //   // If the pressed key is Enter
  //   console.log("checkForEnter")
  //   if (e.keyCode === 13 || e.which === 13) {
  //     this.getResults()
  //   }
  // }


  // async getResults() {
  //   try {
  //     const searchTerm = this.searchField.value
  //     const searchType = this.searchType.value // Get the current selected value
  //     console.log("searchType: " + searchType)
  //     const response = await axios.get(
  //       `${siteData.root_url}/wp-json/fashiontextile/v1/search?term=${searchTerm}&type=${searchType}`
  //     )
  //     const results = response.data
  //     console.log(results)

  //     // Check if there are any results in any of the categories
  //     const hasResults = Object.keys(results).some(
  //       (category) => results[category].length > 0
  //     )

  //     function isUpcomingOrToday(dateString) {
  //       const today = new Date();
  //       today.setHours(0, 0, 0, 0);  // Set to start of today
  //       const eventDate = new Date(dateString.substring(0, 4), dateString.substring(4, 6) - 1, dateString.substring(6));
  //       return eventDate >= today;
  //     }
      
  //     // Function to format a date string from 'yyyymmdd' to 'dd MMM yyyy'
  //     function formatDate(dateString) {
  //       const options = { year: 'numeric', month: 'short', day: 'numeric' };
  //       const date = new Date(dateString.substring(0, 4), dateString.substring(4, 6) - 1, dateString.substring(6));
  //       return date.toLocaleDateString('en-GB', options);
  //     }    
      
  //     const today = new Date();
  //     const formattedToday = `${today.getFullYear()}${(today.getMonth() + 1).toString().padStart(2, '0')}${today.getDate().toString().padStart(2, '0')}`;

  //     if (hasResults) {


  //     this.resultsDiv.innerHTML = `
  //           <div class="row">
            // ${
            //   results.generalInfo.length
            //     ? `
                
            //     <div class="col-12 col-lg-3 results-container">
            //         <h2 class="heading-4">General Information</h2>
            //         ${
            //           results.generalInfo.length
            //             ? '<ul>'
            //             : "<p>No general information matches that search.</p>"
            //         }
            //         ${results.generalInfo
            //           .map(
            //             (item) =>
            //               `<li><a href="${item.permalink}">${item.title}</a> ${
            //                 item.postType == "post"
            //                   ? `by ${item.authorName}`
            //                   : ""
            //               }</li>`
            //           )
            //           .join("")}
            //         ${results.generalInfo.length ? "</ul>" : ""}
            //     </div>
                
            //     `
            //     : ""
            // }

  //           ${
  //             results.exhibitiondisplays.filter(item => (formattedToday >= item.dateFrom && formattedToday <= item.dateTo) || item.dateFrom >= formattedToday).length
  //               ? `
  //                 <div class="col-12 col-lg-3 results-container">
  //                   <h2 class="heading-4">Exhibitions & Displays</h2>
  //                   <ul class="link-list min-list">
  //                     ${results.exhibitiondisplays
  //                       .filter(item => (formattedToday >= item.dateFrom && formattedToday <= item.dateTo) || item.dateFrom >= formattedToday)
  //                       .map((item, index, array) => {
  //                         const permalinkWithDates = `${item.permalink}?date_from=${item.dateFrom}&date_to=${item.dateTo}`;
            
  //                         const dateRange = item.dateFrom === item.dateTo 
  //                           ? formatDate(item.dateFrom)
  //                           : `${formatDate(item.dateFrom)} - ${formatDate(item.dateTo)}`;
            
  //                         const linkContent = index === 0 ? `${item.title} - ${dateRange}` : `${dateRange}`;
            
  //                         const linkClass = index !== 0 ? 'dates-only' : '';
            
  //                         const additionalDatesHeading = (index === 1 && array.length > 1) ? `<h3 class="headline headline--teeny-tiny headline--grey headline--uppercase headline--bold" style="position: relative; left: -30px; margin-bottom: 0; margin-top: 1rem;">Additional Dates:</h3>` : '';
            
  //                         // Include the featured image only for the first item (index === 0)
  //                         const featuredImage = index === 0 && item.featuredImageUrl ? `<img src="${item.featuredImageUrl}" class="results-image" alt="${item.title}">` : '';
            
  //                         return `${featuredImage}${additionalDatesHeading}<li>
  //                                   <a href="${permalinkWithDates}" class="${linkClass}">${linkContent}</a>
  //                                 </li>`;
  //                       })
  //                       .join("")}
  //                   </ul>
  //                 </div>
  //                 `
  //                 : results.exhibitiondisplays.some(item => item.dateTo < formattedToday)
  //                 ? `<div class="col-12 col-lg-3 results-container">
  //                     <h2 class="heading-4">Exhibitions & Displays</h2>
  //                     <p>No current or upcoming Exhibitions & Displays match that search but there may be past events. <a href='/past-exhibitons/'>View Past Exhibitions & Displays</a></p>
  //                    </div>`
  //                 : ""
  //           }


  //           ${
  //             results.museumevents.filter(item => (formattedToday >= item.dateFrom && formattedToday <= item.dateTo) || item.dateFrom >= formattedToday).length
  //               ? `
  //                 <div class="col-12 col-lg-3 results-container">
  //                   <h2 class="heading-4">Museum Events</h2>
  //                   <ul class="link-list min-list">
  //                     ${results.museumevents
  //                       .filter(item => (formattedToday >= item.dateFrom && formattedToday <= item.dateTo) || item.dateFrom >= formattedToday)
  //                       .map((item, index, array) => {
  //                         const permalinkWithDates = `${item.permalink}?date_from=${item.dateFrom}&date_to=${item.dateTo}`;
            
  //                         const dateRange = item.dateFrom === item.dateTo 
  //                           ? formatDate(item.dateFrom)
  //                           : `${formatDate(item.dateFrom)} - ${formatDate(item.dateTo)}`;
            
  //                         const linkContent = index === 0 ? `${item.title} - ${dateRange}` : `${dateRange}`;
            
  //                         const linkClass = index !== 0 ? 'dates-only' : '';
            
  //                         const additionalDatesHeading = (index === 1 && array.length > 1) ? `<h3 class="headline headline--teeny-tiny headline--grey headline--uppercase headline--bold" style="position: relative; left: -30px; margin-bottom: 0; margin-top: 1rem;">Additional Dates:</h3>` : '';
            
  //                         // Include the featured image only for the first item (index === 0)
  //                         const featuredImage = index === 0 && item.featuredImageUrl ? `<img src="${item.featuredImageUrl}" class="results-image" alt="${item.title}">` : '';
            
  //                         return `${featuredImage}${additionalDatesHeading}<li>
  //                                   <a href="${permalinkWithDates}" class="${linkClass}">${linkContent}</a>
  //                                 </li>`;
  //                       })
  //                       .join("")}
  //                   </ul>
  //                 </div>
  //                 `
  //                 : results.museumevents.some(item => item.dateTo < formattedToday)
  //                 ? `<div class="col-12 col-lg-3 results-container">
  //                     <h2 class="heading-4">Museum Events</h2>
  //                     <p>No current or upcoming Museum Events match that search but there may be past events. <a href='/past-museum-events/'>View Past Museum Events</a></p>
  //                    </div>`
  //                 : ""
  //           }


  //           ${
  //             results.onlinetalks.filter(item => (formattedToday >= item.dateFrom && formattedToday <= item.dateTo) || item.dateFrom >= formattedToday).length
  //               ? `
  //                 <div class="col-12 col-lg-3 results-container">
  //                   <h2 class="heading-4">Online Talks</h2>
  //                   <ul class="link-list min-list">
  //                     ${results.onlinetalks
  //                       .filter(item => (formattedToday >= item.dateFrom && formattedToday <= item.dateTo) || item.dateFrom >= formattedToday)
  //                       .map((item, index, array) => {
  //                         const permalinkWithDates = `${item.permalink}?date_from=${item.dateFrom}&date_to=${item.dateTo}`;
            
  //                         const dateRange = item.dateFrom === item.dateTo 
  //                           ? formatDate(item.dateFrom)
  //                           : `${formatDate(item.dateFrom)} - ${formatDate(item.dateTo)}`;
            
  //                         const linkContent = index === 0 ? `${item.title} - ${dateRange}` : `${dateRange}`;
            
  //                         const linkClass = index !== 0 ? 'dates-only' : '';
            
  //                         const additionalDatesHeading = (index === 1 && array.length > 1) ? `<h3 class="headline headline--teeny-tiny headline--grey headline--uppercase headline--bold" style="position: relative; left: -30px; margin-bottom: 0; margin-top: 1rem;">Additional Dates:</h3>` : '';
            
  //                         // Include the featured image only for the first item (index === 0)
  //                         const featuredImage = index === 0 && item.featuredImageUrl ? `<img src="${item.featuredImageUrl}" class="results-image" alt="${item.title}">` : '';
            
  //                         return `${featuredImage}${additionalDatesHeading}<li>
  //                                   <a href="${permalinkWithDates}" class="${linkClass}">${linkContent}</a>
  //                                 </li>`;
  //                       })
  //                       .join("")}
  //                   </ul>
  //                 </div>
  //                 `
  //                 : results.onlinetalks.some(item => item.dateTo < formattedToday)
  //                 ? `<div class="col-12 col-lg-3 results-container">
  //                     <h2 class="heading-4">Online Talks</h2>
  //                     <p>No current or upcoming Online Talks match that search but there may be past events. <a href='/past-online-talks/'>View Past Online Talks</a></p>
  //                    </div>`
  //                 : ""
  //           }

  //           ${
  //             results.fashionschools.filter(item => (formattedToday >= item.dateFrom && formattedToday <= item.dateTo) || item.dateFrom >= formattedToday).length
  //               ? `
  //                 <div class="col-12 col-lg-3 results-container">
  //                   <h2 class="heading-4">Fashion School Events</h2>
  //                   <ul class="link-list min-list">
  //                     ${results.fashionschools
  //                       .filter(item => (formattedToday >= item.dateFrom && formattedToday <= item.dateTo) || item.dateFrom >= formattedToday)
  //                       .map((item, index, array) => {
  //                         const permalinkWithDates = `${item.permalink}?date_from=${item.dateFrom}&date_to=${item.dateTo}`;
            
  //                         const dateRange = item.dateFrom === item.dateTo 
  //                           ? formatDate(item.dateFrom)
  //                           : `${formatDate(item.dateFrom)} - ${formatDate(item.dateTo)}`;
            
  //                         const linkContent = index === 0 ? `${item.title} - ${dateRange}` : `${dateRange}`;
            
  //                         const linkClass = index !== 0 ? 'dates-only' : '';
            
  //                         const additionalDatesHeading = (index === 1 && array.length > 1) ? `<h3 class="headline headline--teeny-tiny headline--grey headline--uppercase headline--bold" style="position: relative; left: -30px; margin-bottom: 0; margin-top: 1rem;">Additional Dates:</h3>` : '';
            
  //                         // Include the featured image only for the first item (index === 0)
  //                         const featuredImage = index === 0 && item.featuredImageUrl ? `<img src="${item.featuredImageUrl}" class="results-image" alt="${item.title}">` : '';
            
  //                         return `${featuredImage}${additionalDatesHeading}<li>
  //                                   <a href="${permalinkWithDates}" class="${linkClass}">${linkContent}</a>
  //                                 </li>`;
  //                       })
  //                       .join("")}
  //                   </ul>
  //                 </div>
  //                 `
  //                 : results.fashionschools.some(item => item.dateTo < formattedToday)
  //                 ? `<div class="col-12 col-lg-3 results-container">
  //                     <h2 class="heading-4">Fashion School</h2>
  //                     <p>No current or upcoming Fashion School Events match that search but there may be past events. <a href='/past-fashion-school/'>View Past Fashion School Events</a></p>
  //                    </div>`
  //                 : ""
  //           } 


  //           ${
  //             results.digitaldesigncourses.filter(item => (formattedToday >= item.dateFrom && formattedToday <= item.dateTo) || item.dateFrom >= formattedToday).length
  //               ? `
  //                 <div class="col-12 col-lg-3 results-container">
  //                   <h2 class="heading-4">Digital Design Courses</h2>
  //                   <ul class="link-list min-list">
  //                     ${results.digitaldesigncourses
  //                       .filter(item => (formattedToday >= item.dateFrom && formattedToday <= item.dateTo) || item.dateFrom >= formattedToday)
  //                       .map((item, index, array) => {
  //                         const permalinkWithDates = `${item.permalink}?date_from=${item.dateFrom}&date_to=${item.dateTo}`;
            
  //                         const dateRange = item.dateFrom === item.dateTo 
  //                           ? formatDate(item.dateFrom)
  //                           : `${formatDate(item.dateFrom)} - ${formatDate(item.dateTo)}`;
            
  //                         const linkContent = index === 0 ? `${item.title} - ${dateRange}` : `${dateRange}`;
            
  //                         const linkClass = index !== 0 ? 'dates-only' : '';
            
  //                         const additionalDatesHeading = (index === 1 && array.length > 1) ? `<h3 class="headline headline--teeny-tiny headline--grey headline--uppercase headline--bold" style="position: relative; left: -30px; margin-bottom: 0; margin-top: 1rem;">Additional Dates:</h3>` : '';
            
  //                         // Include the featured image only for the first item (index === 0)
  //                         const featuredImage = index === 0 && item.featuredImageUrl ? `<img src="${item.featuredImageUrl}" class="results-image" alt="${item.title}">` : '';
            
  //                         return `${featuredImage}${additionalDatesHeading}<li>
  //                                   <a href="${permalinkWithDates}" class="${linkClass}">${linkContent}</a>
  //                                 </li>`;
  //                       })
  //                       .join("")}
  //                   </ul>
  //                 </div>
  //                 `
  //                 : results.digitaldesigncourses.some(item => item.dateTo < formattedToday)
  //                 ? `<div class="col-12 col-lg-3 results-container">
  //                     <h2 class="heading-4">Digital Design Courses</h2>
  //                     <p>No current or upcoming Digital Design Courses match that search but there may be past events. <a href='/digital-design-courses/'>View All Digital Design Courses</a></p>
  //                    </div>`
  //                 : ""
  //           }


  //           ${
  //             results.workshops.filter(item => (formattedToday >= item.dateFrom && formattedToday <= item.dateTo) || item.dateFrom >= formattedToday).length
  //               ? `
  //                 <div class="col-12 col-lg-3 results-container">
  //                   <h2 class="heading-4">Workshops</h2>
  //                   <ul class="link-list min-list">
  //                     ${results.workshops
  //                       .filter(item => (formattedToday >= item.dateFrom && formattedToday <= item.dateTo) || item.dateFrom >= formattedToday)
  //                       .map((item, index, array) => {
  //                         const permalinkWithDates = `${item.permalink}?date_from=${item.dateFrom}&date_to=${item.dateTo}`;
            
  //                         const dateRange = item.dateFrom === item.dateTo 
  //                           ? formatDate(item.dateFrom)
  //                           : `${formatDate(item.dateFrom)} - ${formatDate(item.dateTo)}`;
            
  //                         const linkContent = index === 0 ? `${item.title} - ${dateRange}` : `${dateRange}`;
            
  //                         const linkClass = index !== 0 ? 'dates-only' : '';
            
  //                         const additionalDatesHeading = (index === 1 && array.length > 1) ? `<h3 class="headline headline--teeny-tiny headline--grey headline--uppercase headline--bold" style="position: relative; left: -30px; margin-bottom: 0; margin-top: 1rem;">Additional Dates:</h3>` : '';
            
  //                         // Include the featured image only for the first item (index === 0)
  //                         const featuredImage = index === 0 && item.featuredImageUrl ? `<img src="${item.featuredImageUrl}" class="results-image" alt="${item.title}">` : '';
            
  //                         return `${featuredImage}${additionalDatesHeading}<li>
  //                                   <a href="${permalinkWithDates}" class="${linkClass}">${linkContent}</a>
  //                                 </li>`;
  //                       })
  //                       .join("")}
  //                   </ul>
  //                 </div>
  //                 `
  //                 : results.workshops.some(item => item.dateTo < formattedToday)
  //                 ? `<div class="col-12 col-lg-3 results-container">
  //                     <h2 class="heading-4">Workshops</h2>
  //                     <p>No current or upcoming Workshops match that search but there may be past events. <a href='/past-workshops/'>View Past Workshops</a></p>
  //                    </div>`
  //                 : ""
  //           }




            // ${
            //   results.ondemands.length
            //     ? `
                
            //     <div class="col-12 col-lg-3 results-container">
            //         <h2 class="heading-4">On Demand</h2>
            //         ${
            //           results.ondemands.length
            //             ? '<ul>'
            //             : "<p>No On Demand Events match that search.</p>"
            //         }
            //         ${results.ondemands
            //           .map(
            //             (item) =>
            //               `<li>
            //                 ${item.featuredImageUrl ? `<img src="${item.featuredImageUrl}" class="results-image" style="left: 0;" alt="${item.title}"></img>` : ''}
            //                 <a href="${item.permalink}">${item.title}</a>
            //               </li>`
            //           )
                      
            //           .join("")}
            //         ${results.generalInfo.length ? "</ul>" : ""}
            //     </div>
                
            //     `
            //     : ""
            // }



                

  //           ${
  //             results.touringexhibitions.filter(item => (formattedToday >= item.dateFrom && formattedToday <= item.dateTo) || item.dateFrom >= formattedToday).length
  //               ? `
  //                 <div class="col-12 col-lg-3 results-container">
  //                   <h2 class="heading-4">Touring Exhibitions</h2>
  //                   <ul class="link-list min-list">
  //                     ${results.touringexhibitions
  //                       .filter(item => (formattedToday >= item.dateFrom && formattedToday <= item.dateTo) || item.dateFrom >= formattedToday)
  //                       .map((item, index, array) => {
  //                         const permalinkWithDates = `${item.permalink}?date_from=${item.dateFrom}&date_to=${item.dateTo}`;
            
  //                         const dateRange = item.dateFrom === item.dateTo 
  //                           ? formatDate(item.dateFrom)
  //                           : `${formatDate(item.dateFrom)} - ${formatDate(item.dateTo)}`;
            
  //                         const linkContent = index === 0 ? `${item.title} - ${dateRange}` : `${dateRange}`;
            
  //                         const linkClass = index !== 0 ? 'dates-only' : '';
            
  //                         const additionalDatesHeading = (index === 1 && array.length > 1) ? `<h3 class="headline headline--teeny-tiny headline--grey headline--uppercase headline--bold" style="position: relative; left: -30px; margin-bottom: 0; margin-top: 1rem;">Additional Dates:</h3>` : '';
            
  //                         // Include the featured image only for the first item (index === 0)
  //                         const featuredImage = index === 0 && item.featuredImageUrl ? `<img src="${item.featuredImageUrl}" class="results-image" alt="${item.title}">` : '';
            
  //                         return `${featuredImage}${additionalDatesHeading}<li>
  //                                   <a href="${permalinkWithDates}" class="${linkClass}">${linkContent}</a>
  //                                 </li>`;
  //                       })
  //                       .join("")}
  //                   </ul>
  //                 </div>
  //                 `
  //                 : results.touringexhibitions.some(item => item.dateTo < formattedToday)
  //                 ? `<div class="col-12 col-lg-3 results-container">
  //                     <h2 class="heading-4">Touring Exhibitions</h2>
  //                     <p>No current or upcoming Touring Exhibitions match that search but there may be past events. <a href='/past-touring-exhibitions/'>View Past Touring Exhibitions</a></p>
  //                    </div>`
  //                 : ""
  //           } 
  //           </div>
  //       `
  //     } else {
  //       this.resultsDiv.innerHTML = "<div class='col-12 col-lg-3 results-container'><p>There are no results for your search.</p></div>"
  //     }        
  //     this.isSpinnerVisible = false
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }

  // keyPressDispatcher(e) {
  //   if (
  //     e.keyCode == 83 &&
  //     !this.isOverlayOpen &&
  //     document.activeElement.tagName != "INPUT" &&
  //     document.activeElement.tagName != "TEXTAREA"
  //   ) {
  //     this.openOverlay()
  //   }

  //   if (e.keyCode == 27 && this.isOverlayOpen) {
  //     this.closeOverlay()
  //   }
  // }

  // openOverlay() {
  //   this.searchOverlay.classList.add("search-overlay--active")
  //   document.body.classList.add("body-no-scroll")
  //   this.searchField.value = ""
  //   setTimeout(() => this.searchField.focus(), 301)
  //   this.isOverlayOpen = true
  //   return false
  // }

  // closeOverlay() {
  //   this.searchOverlay.classList.remove("search-overlay--active")
  //   document.body.classList.remove("body-no-scroll")
  //   this.isOverlayOpen = false
  // }

  // addSearchHTML() {
  //   document.body.insertAdjacentHTML(
  //     "beforeend",
  //     `
  //       <div class="search-overlay">
  //       <div class="container-fluid" style="padding: 0;">
  //           <div class="search-overlay__top">
  //           <div class="container">
  //           <div class="row search-overlay__top-row">
  //               <div class="col-12 col-lg-3">
  //                   <input type="text" class="search-term" placeholder="Please enter search term here" id="search-term" />
  //               </div>
  //               <div class="col-12 col-lg-3">
  //                   <select class="search-filter" id="search-type">
  //                       <option value="all-site">All Site</option>
  //                       <option value="all-events">All Events</option>
  //                       <option value="exhibitiondisplay">Exhibitions & Displays</option>
  //                       <option value="museumevent">Museum Events</option>
  //                       <option value="onlinetalk">Online Talks</option>
  //                       <option value="fashionschool">Fashion School</option>
  //                       <option value="digitaldesigncourse">Digital Design Courses</option>
  //                       <option value="ondemand">On Demand</option>
  //                       <option value="workshop">Workshops</option>
  //                       <option value="touringexhibition">Touring Exhibitions</option>
  //                   </select>
  //               </div>                

  //               <div class="col-12 col-lg-2">
  //                   <div id="send-search" class="search-overlay-button">Search</div>
  //               </div>  
  //               <div class="col-12 col-lg-2">
  //                   <div class="search-overlay-button search-overlay__close">Close</div>
  //               </div>  
  //               </div>                                             
  //           </div>
  //           </div>
  //           <div class="container">
  //               <div id="search-overlay__results"></div>
  //           </div>
  //       </div>
  //       </div>
  //   `
  //   )
  // }
}

export default Search
